module.exports = __webpack_public_path__ + "static/media/csv-file.57f412df.svg";